import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/views/app/Index'),
      redirect: '/dashboard',

      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/app/dashboard/Route'),
          children: [
            {
              name: 'DashboardPage',
              path: '',
              component: () => import('@/views/app/dashboard/Dashboard'),
              meta: { onlyAuthUser: true },
            },
            {
              path: 'new',
              name: 'NewTemplate',
              component: () => import('@/views/app/dashboard/NewTemplate'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':template_id',
              name: 'TemplateDetails',
              component: () => import('@/views/app/dashboard/TemplateDetails'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/production',
          component: () => import('@/views/app/dashboard/Route'),
          children: [
            {
              name: 'ProductionPage',
              path: '',
              component: () => import('@/views/app/dashboard/Production'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':template_id',
              name: 'ProductionTemplateDetails',
              component: () => import('@/views/app/dashboard/ProductionTemplateDetails'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/nexrender',
          component: () => import('@/views/app/dashboard/Route'),
          children: [
            {
              name: 'NexrenderPage',
              path: '',
              component: () => import('@/views/app/dashboard/JobList'),
              meta: { onlyAuthUser: true },
            },
            {
              path: 'new',
              name: 'NewNexrenderJob',
              component: () => import('@/views/app/dashboard/NewJob'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':job_id',
              name: 'NexrenderJobDetails',
              component: () => import('@/views/app/dashboard/JobDetails'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/settings',
          component: () => import('@/views/app/dashboard/Route'),
          children: [
            {
              name: 'SettingsPage',
              path: '',
              component: () => import('@/views/app/dashboard/Settings'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
      ],
    },
    {
      path: '/signin',
      component: () => import('@/views/app/sessions/Sessions'),
      children: [
        {
          name: 'SignIn',
          path: '',
          component: () => import('@/views/app/sessions/SignIn'),
          meta: { onlyGuestUser: true },
        },
      ],
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
  data () {
    return {
      prevRoute: null,
    }
  },
})

router.beforeEach((to, from, next) => {
  router.prevRoute = from
  store.dispatch('tryAutoLogin')
    .then(() => {
      const { isAuthenticated } = store.getters

      if (isAuthenticated && to.meta.onlyGuestUser) {
        next({ path: '/' })
      } else if (!isAuthenticated && to.meta.onlyAuthUser) {
        next({ name: 'SignIn' })
      } else {
        next()
      }
    })
    .catch(() => {
      next({ name: 'SignIn' })
    })
})

export default router
